import angular from 'angular';
import Logger from '../../../shared/logger';

export class EmployerSearchComponent {
    /* @ngInject */
    constructor($scope, $stateParams, PositionService) {
        PositionService.getPosition($stateParams.positionId)
            .then((response) => {
                $scope.positionData = response.result;
                $scope.data = {
                    employerId: $stateParams.employerId,
                    positionId: $stateParams.positionId,
                    currSearchHistoryIndex: $stateParams.currSearchHistoryIndex,
                    currCandidatePage: $stateParams.currCandidatePage,
                    talentID: $stateParams.talentID,
                    scroll: $stateParams.scroll,
                    searchName: $stateParams.searchName,
                    showView: 'MainSearch',
                    candidatesName: $stateParams.candidatesName,
                    positionData: $scope.positionData,
                };
            })
            .catch(error => Logger.error(error));
    }
}

export const EmployerSearchComponentConfiguration = {
    template: '<search-component ng-if="data" search-data="data"></search-component>',
    controller: EmployerSearchComponent,
};

angular.module('TALENYA-FE').component('employerSearch', EmployerSearchComponentConfiguration);